import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import Client1 from "../../../../../assets/img/Client_Frame.png";
import Client2 from "../../../../../assets/img/Client_Frame_002.png";
import Client3 from "../../../../../assets/img/Client_Frame_003.png";
import Client4 from "../../../../../assets/img/Client_Frame_004.png";
import Client5 from "../../../../../assets/img/Client_Frame_005.png";
import Client6 from "../../../../../assets/img/Client_Frame_006.png";
import Client7 from "../../../../../assets/img/Client_Frame_007.png";
import Client8 from "../../../../../assets/img/Client_Frame_008.png";

const logos = [Client1, Client2, Client3, Client4, Client5, Client6, Client7, Client8];

const TrustedCompanies = () => {
  const { t: translate } = useTranslation();

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Typography
        fontSize="16px"
        fontWeight={400}
        lineHeight="24px"
        color="white"
        fontFamily="Manrope"
        sx={{
          mb: 2,
          letterSpacing: "0.5px",
        }}
      >
        {translate("signup.right.trustedBy", "Trusted by industry leaders worldwide")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 6,
          animation: "scrollLeft 25s linear infinite",
          width: "max-content",
        }}
      >

        {[...logos, ...logos].map((logo, index) => (
          <Box
            key={index}
            component="img"
            src={logo}
            alt={`Client ${index + 1}`}
            sx={{
              height: { xs: 40, md: 60 },
              flexShrink: 0,
              filter: "brightness(200%)",
            }}
          />
        ))}
      </Box>

      <style>
        {`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </Box>
  );
};

export default TrustedCompanies;
